import { useT } from "../i18n/hooks.ts";
import type { ProjectMeta } from "../model/storage.ts";
import { Dialog } from "./Dialog.tsx";

/**
 * Shown once, right after Drive connects (or silently reconnects) and finds
 * local projects it doesn't have a copy of yet (see driveSyncStore.ts's
 * `reconcile` and useProjectPersistence.ts's startup effect) — never
 * uploads them without asking first, same "nothing happens silently"
 * principle as everywhere else Drive touches local data.
 */
export function UploadExistingProjectsDialog({
  projects,
  onUploadAll,
  onClose,
}: {
  projects: ProjectMeta[];
  onUploadAll: () => void;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <Dialog title={t("driveSync.uploadExistingTitle")} onClose={onClose} anchor="top-right">
      <p>
        {t(projects.length === 1 ? "driveSync.unsyncedCount" : "driveSync.unsyncedCountPlural", {
          n: projects.length,
        })}
      </p>
      <ul className="editable-list">
        {projects.map((p) => (
          <li key={p.id}>{p.name}</li>
        ))}
      </ul>
      <div className="dialog-actions">
        <button
          className="button button-primary"
          onClick={() => {
            onUploadAll();
            onClose();
          }}
        >
          {t("driveSync.uploadAll")}
        </button>
        <button className="button" onClick={onClose}>
          {t("driveSync.notNow")}
        </button>
      </div>
    </Dialog>
  );
}
